import PropTypes from 'prop-types';
import React from 'react';

function Voice(props) {
  const { fill } = props;
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_13680_234385)">
        <path
          d="M12.3083 20.1584L12.3166 20.1643C13.0367 20.6227 13.8916 20.8218 14.7401 20.7286C15.5886 20.6355 16.3799 20.2556 16.9833 19.6518L17.5075 19.1276C17.6236 19.0115 17.7158 18.8737 17.7786 18.722C17.8415 18.5703 17.8739 18.4077 17.8739 18.2434C17.8739 18.0792 17.8415 17.9166 17.7786 17.7649C17.7158 17.6132 17.6236 17.4754 17.5075 17.3593L15.2966 15.1501C15.1805 15.034 15.0427 14.9418 14.891 14.8789C14.7393 14.8161 14.5767 14.7837 14.4125 14.7837C14.2482 14.7837 14.0856 14.8161 13.9339 14.8789C13.7822 14.9418 13.6444 15.034 13.5283 15.1501V15.1501C13.2939 15.3845 12.976 15.5161 12.6445 15.5161C12.3131 15.5161 11.9952 15.3845 11.7608 15.1501L8.22579 11.6143C7.99145 11.3799 7.85981 11.062 7.85981 10.7305C7.85981 10.3991 7.99145 10.0812 8.22579 9.84678V9.84678C8.34195 9.7307 8.43409 9.59286 8.49696 9.44115C8.55983 9.28944 8.59219 9.12683 8.59219 8.96261C8.59219 8.79839 8.55983 8.63578 8.49696 8.48407C8.43409 8.33236 8.34195 8.19453 8.22579 8.07845L6.01579 5.86928C5.78138 5.63494 5.46349 5.5033 5.13204 5.5033C4.80058 5.5033 4.4827 5.63494 4.24829 5.86928L3.72329 6.39345C3.11961 6.99693 2.73989 7.7883 2.64686 8.63681C2.55382 9.48531 2.75305 10.3402 3.21162 11.0601L3.21662 11.0684C5.63844 14.6516 8.72469 17.7373 12.3083 20.1584V20.1584Z"
          fill="none"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.25"
        />
        <path d="M16.375 3.25H21.375" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.25" />
        <path d="M16.375 7H21.375" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.25" />
        <path d="M16.375 10.75H21.375" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.25" />
        <path d="M12.625 3.25H13.875" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.25" />
        <path d="M12.625 7H13.875" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.25" />
        <path d="M12.625 10.75H13.875" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.25" />
      </g>
      <defs>
        <clipPath id="clip0_13680_234385">
          <rect fill="white" height="20" transform="translate(2 2)" width="20" />
        </clipPath>
      </defs>
    </svg>
  );
}

Voice.propTypes = {
  fill: PropTypes.string.isRequired
};

export default Voice;
